import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FolderIconShortcutSvg = function FolderIconShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AA8226",
    fillRule: "evenodd",
    d: "M21 20c0 1.11-.893 2-1.995 2h-8.94A9 9 0 0 0 0 9.223V3.991A2 2 0 0 1 1.999 2h6c1.113 0 2.147.88 2.328 1.968l.008.05c.09.54.615.982 1.17.982H19a2 2 0 0 1 2 2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE385",
    fillRule: "evenodd",
    d: "M10.065 22h8.94c1.102 0 2.17-.871 2.387-1.961l2.216-11.078C23.825 7.878 23.098 7 22.006 7H4.995c-1.102 0-2.169.871-2.387 1.961l-.012.058A9 9 0 0 1 10.065 22",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var FolderIconShortcut = function FolderIconShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FolderIconShortcutSvg
  }));
};